var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        attrs: {
          title: "화학물질 변경내역 목록",
          columns: _vm.columns,
          data: _vm.displayRows,
          gridHeight: _vm.gridHeight,
          usePaging: false,
          customTrClass: (_props) =>
            (_props.row.casNo && !_props.row.mdmChemId) ||
            _props.row.newChemFlag === "Y"
              ? "bg-orange-1"
              : "",
        },
        scopedSlots: _vm._u([
          {
            key: "table-chip",
            fn: function () {
              return [
                _vm.newChemRows.length > 0
                  ? _c(
                      "span",
                      {
                        staticClass: "q-ml-lg text-deep-purple",
                        staticStyle: { "font-size": "0.94em" },
                      },
                      [
                        _vm._v(
                          " ✔️ 기존 화학물질에 없는 건은 오렌지색으로 표시되며, 규제 적용 시 화학물질에 신규로 등록됩니다. (총 " +
                            _vm._s(_vm.newChemRows.length) +
                            " 건) "
                        ),
                        _c("q-chip", {
                          staticClass: "q-ml-sm",
                          attrs: {
                            outline: "",
                            square: "",
                            clickable: "",
                            size: "12px",
                            color: "orange",
                            label: _vm.newChemOnly
                              ? "전체보기"
                              : "신규 물질만 보기",
                          },
                          on: {
                            click: function ($event) {
                              _vm.newChemOnly = !_vm.newChemOnly
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "table-button",
            fn: function () {
              return [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _vm.editable && _vm.param.statusCd === "CEUS000005"
                      ? _c("c-btn", {
                          attrs: { label: "삭제", icon: "delete_forever" },
                          on: { btnClicked: _vm.deleteUpload },
                        })
                      : _vm._e(),
                    _vm.editable && _vm.param.statusCd === "CEUS000005"
                      ? _c("c-btn", {
                          attrs: { label: "규제 적용", icon: "check" },
                          on: { btnClicked: _vm.applyRegulation },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "customArea",
            fn: function ({ props, col }) {
              return [
                col.name === "impactMaterials"
                  ? [
                      _vm._l(
                        props.row.impactMaterials || [],
                        function (material, index) {
                          return [
                            _c(
                              "span",
                              {
                                key: material.mdmChemMaterialId,
                                staticClass:
                                  "tableinnerBtn tableinnerBtn-left cursor-pointer text-blue-6",
                                on: {
                                  click: function ($event) {
                                    return _vm.openMaterial(
                                      material.mdmChemMaterialId
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(material.mdmChemMaterialName))]
                            ),
                            index < (props.row.impactMaterials || []).length - 1
                              ? _c(
                                  "span",
                                  {
                                    key: "sep" + material.mdmChemMaterialId,
                                    staticClass: "q-mr-xs",
                                  },
                                  [_vm._v(", ")]
                                )
                              : _vm._e(),
                          ]
                        }
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }